<div class="import-wizard-modal">
    <button class="close-button" (click)="handleClose()">
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
            d="M18 6L6 18M6 6l12 12"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            />
        </svg>
    </button>

    @if(type() === ImportWizardType.GEOSPATIAL) {
        <app-import-wizard-geospatial></app-import-wizard-geospatial>
    } 

     @if(type() === ImportWizardType.TABULAR) {
        <app-import-wizard-tabular></app-import-wizard-tabular>
    }

    @if(type() === ImportWizardType.PENDING_LIST) { 
        <app-import-wizard-pending-list></app-import-wizard-pending-list>
    }
    
</div>


<app-alert
title="Sair do processo de importação?"
message="Foram feitas alterações na etapa de mapeamento. Se sair agora, essas mudanças serão perdidas."
confirmText="Sair sem salvar"
cancelText="Continuar editando"
[visible]="isHasMappingChangesAlertOpen()"
(onConfirmEvent)="handleHasMappingChangersAlertConfirm()"
(onCancelEvent)="handleHasMappingChangersAlertCancel()"
></app-alert>